import React from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import WeatherForecastComponent from "./components/weather/WeatherForecast";

type WeatherForecastProps = {
  apiUrl: string;
};

const WeatherForecast = ({ apiUrl }: WeatherForecastProps) => (
  <div id="dacom-online">
    <Provider store={store}>
      <WeatherForecastComponent apiUrl={apiUrl} />
    </Provider>
  </div>
);

export default WeatherForecast;
